/*
 app dependencies
 - var body

 lib dependencies
*/

const scUser = (function($)
{

	//module functions
	/*function init()
	{
		_getTopNav();
	}

	function _getTopNav()
	{
		if (document.querySelector('.js-top-nav-account-placeholder'))
		{
			doAjax({
				ajaxUrl: '/ajax/get-top-nav',
				onSuccess: _onTopNavSuccess,
				onError: _onTopNavError
			});
		}
	}

		function _onTopNavSuccess(rawResponse, params)
		{
			try
			{
				var response = $.parseJSON(rawResponse);
				if (response.success)
				{
					//update top nav
					document.querySelector('.js-top-nav-account-placeholder').outerHTML = response.html;
					//set state
					scState.isLoggedIn = +response.isLoggedIn === 1;
					//header login for mobile
					// const headerLoginToggle = document.querySelector('.js-account-toggle');
					// if (headerLoginToggle)
					// {
					// 	headerLoginToggle.addEventListener('click', function(e)
					// 	{
					// 		e.preventDefault();
					// 		scUi.loginPopup('');
					// 	});
					// }
				}
				else throw new Error(response.message);
			}
			catch (err) { alert(err.message); }
		}


		function _onTopNavError(jqxhr, textStatus, errorThrown, params)
		{

		}*/

	//top nav via lmnDynamicPageContents (in lmnAjax)
	function onTopNav(isLoggedIn)
	{
		scState.isLoggedIn = +isLoggedIn === 1;
	}


	//reveal public vars and functions
	return {
		//vars

		//functions
		//init
		onTopNav
	};

})(jQuery);
